export default {
  en: {
    MaterialEditScene: {
      title: 'Edit material',
    },
  },
};
